import React, { useState, useEffect } from 'react';
import Slider from '@mui/material/Slider';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import BottomNavigation from '@mui/material/BottomNavigation';
import Paper from '@mui/material/Paper';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import HighlightIcon from '@mui/icons-material/Highlight';
import SubtitlesIcon from '@mui/icons-material/Subtitles';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import logo from './Components/Assets/smorse.png'
import { createTheme, ThemeProvider } from '@mui/material/styles';
// import Webcam from "react-webcam";
// import cv from "@techstark/opencv-js";
// import cv from 'opencv.js';
// import {setIntervalAsync} from 'set-interval-async';
import offcomp from './Components/Assets/offcomp.png';
import oncomp from './Components/Assets/oncomp.png'
import slidercomp from './Components/Assets/slidercomp.png'
import startcomp from './Components/Assets/startcomp.png'
import receivecomp from './Components/Assets/receivecomp.png'

const WebcamStreamCapture = () => {
    const webcamRef = React.useRef(null);
    const mediaRecorderRef = React.useRef(null);
    const [capturing, setCapturing] = React.useState(false);
    const [recordedChunks, setRecordedChunks] = React.useState([]);
    const [targetX, setTargetX] = React.useState(320);
    const [targetY, setTargetY] = React.useState(240);
    const [resState, setResState] = React.useState("");
    const [decodedState, setDecodedState] = React.useState("");
    const [threshold, setThreshold] = React.useState(100);
    const [allowCamera, setAllowCamera] = React.useState(false);
    const [dbg, setDbg] = React.useState("dbg");
    const [value, setValue] = React.useState(1);
    const [screenWidth, setScreenWidth] = React.useState(0);
    const [screenHeight, setScreenHeight] = React.useState(0);
    const [isRecording, setIsRecording] = React.useState(false);
    const [isTransmitting, setIsTransmitting] = React.useState(false);
    const [currentLetter, setCurrentLetter] = React.useState("");
    const [toSend, setToSend] = React.useState("");
    const [stream, setStream] = React.useState(null);
    const morsedct = {        '-----': '0',         '.----': '1',         '..---': '2', 
        '...--': '3',        '....-': '4',        '.....': '5',        '-....': '6', 
        '--...': '7',        '---..': '8',        '----.': '9',        '.-': 'a',
        '-...': 'b',         '-.-.': 'c',         '-..': 'd',         '.': 'e', 
        '..-.': 'f',        '--.': 'g',        '....': 'h',        '..': 'i', 
        '.---': 'j',        '-.-': 'k',        '.-..': 'l',        '--': 'm',
        '-.': 'n',        '---': 'o',        '.--.': 'p',        '--.-': 'q',
        '.-.': 'r',        '...': 's',        '-': 't',        '..-': 'u', 
        '...-': 'v',        '.--': 'w',        '-..-': 'x',        '-.--': 'y', 
        '--..': 'z',        '.-.-.-': '.',        '--..--': ',',        '..--..': '?', 
        '-.-.--': '!',        '-....-': '-',        '-..-.': '/',         '.--.-.': '@',
        '-.--.': '(',        '-.--.-': ')','...---...': 'SOS',
    }

    // const theme = createTheme({
    //     palette: {
    //       primary: "#f5b145",
    //       secondary: "#9c5a3c",
    //     },
    //   });

      const theme = createTheme({
        palette: {
          primary: {
            main: '#f5b145',
            // light: will be calculated from palette.primary.main,
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
          },
          secondary: {
            main: '#9c5a3c',
            light: '#F5EBFF',
            // dark: will be calculated from palette.secondary.main,
            contrastText: '#47008F',
          },
        },
      });

    const reverseDct = {'0': '-----', '1': '.----', '2': '..---', '3': '...--', '4': '....-', '5': '.....', '6': '-....', '7': '--...', '8': '---..', '9': '----.', 'a': '.-', 'b': '-...', 'c': '-.-.', 'd': '-..', 'e': '.', 'f': '..-.', 'g': '--.', 'h': '....', 'i': '..', 'j': '.---', 'k': '-.-', 'l': '.-..', 'm': '--', 'n': '-.', 'o': '---', 'p': '.--.', 'q': '--.-', 'r': '.-.', 's': '...', 't': '-', 'u': '..-', 'v': '...-', 'w': '.--', 'x': '-..-', 'y': '-.--', 'z': '--..', '.': '.-.-.-', ',': '--..--', '?': '..--..', '!': '-.-.--', '-': '-....-', '/': '-..-.', '@': '.--.-.', '(': '-.--.', ')': '-.--.-', 'SOS': '...---...'}
    
    const marks = [ 
     {    value: 50,    label: '50',  },  {    value: 100,    label: '100',  },
     {    value: 150,    label: '150',  },{    value: 200,    label: '200',  },
     {    value: 240,    label: '240',  }];

    var ct = 0;
    const [frmct, setFrmct] = React.useState(0);
    var x = 200;
    var y = 175;
    var bits = [];
    // var threshold = 100;
    var dahlen = 3;
    var negBitCount = 0;
    var posBitCount = 0;
    var res = "";
    var decoded = "";
    var media = null;
    

    // var morseL = function() {
    //     $('h2').removeClass('short long');
    //     $('h2').addClass('long');
    //     setTimeout(function(){
    //       $('h2').removeClass('long');
    //     }, 1200);
    //   }

    function updateDecode() {
        decoded = ""
        var newChar = "";
        var rawspace = res.split("//")
        for (var index in rawspace) {
            var raw = rawspace[index].split("/")
            for (var rawIndex in raw) {
                if (raw[rawIndex].length == 0) {
                    continue
                }
                try {
                    var newLetter = morsedct[raw[rawIndex]] 
                    if (newLetter != null)
                        newChar = morsedct[raw[rawIndex]] 
                        decoded += newChar
                        setDecodedState(decoded)
                } catch {
                    // console.log("not found:", raw[rawIndex])
                    continue
                }
            }
            newChar = " "
            decoded += newChar
            setDecodedState(decoded)
        }
        
    }

    function readBitStream() {
        if (bits.length >= 30) {
            var curBit = bits.shift()
        }

        if (curBit == "X") {
            // space between word
            if (negBitCount >= (dahlen*10)) {
                res += "//"
            } else if (negBitCount >= (dahlen*4)) {
                res += "/"
            }
            negBitCount = 0
            posBitCount += 1
        } else {
            //  at state change, measure length and add accordingly
            if (posBitCount >= (dahlen*3) && posBitCount < (dahlen*10)) {
                res += "-"
            } else if (posBitCount >= dahlen) {
                res += "."
            }
            posBitCount = 0
            negBitCount += 1
        }
    }

    function getBrightness(imageData) {
        var colorSum = 0;
        let data = imageData.data;
        for (var i = 0; i < data.length; i += 4) {
            var r = data[i];
            var g = data[i + 1];
            var b = data[i + 2];
            var avg = Math.floor((r + g + b) / 3);
            colorSum += avg;
          }
        let brightness = Math.floor(colorSum / (imageData.width * imageData.height));
        return brightness;
    }

    function captureVideo(thresh) {
        //TODO: avoid doing this every single render
        var video = document.querySelector("video");
        // window.alert(typeof video)
        var view = document.getElementById("view");
        var ctx = view.getContext("2d");

        // make target in middle of canvas by trimming
        if (screenWidth > video.videoWidth) {
            var xBuffer = screenWidth - video.videoWidth;
            xBuffer = Math.round(xBuffer / 2);
        }
        if (screenHeight > video.videohHeight) {
            var yBuffer = screenHeight - video.videohHeight;
            yBuffer = Math.round(yBuffer / 2);
        }
        ctx.drawImage(video, 0, 0);

        ct += 1;
        setFrmct(ct);

        readBitStream();

        if (ct % 15 == 0) {
            // updateDecode every 0.5s to save computing power
            setResState(res);
            updateDecode();
        }
        // console.log(resState)
        var imgd = ctx.getImageData(Math.max(x-25, 0), Math.max(y-25, 0), 50, 50); //.scale(2);

        var brightnessVal = getBrightness(imgd);
        let isBright = brightnessVal > thresh;
        if (isBright) {
            bits.push("X")
        } else {
            bits.push(" ")
        }

        // portctx.putImageData(imgd, 50, 50);

        ctx.strokeStyle = "blue";
        ctx.lineWidth = 5;

        ctx.beginPath();
        ctx.arc(x, y, 20, 0, 2 * Math.PI);
        // ctx.rect(20, 20, 150, 100);
        ctx.stroke();

        ctx.textAlign = "center";

        ctx.fillStyle = "white";
        ctx.font = "30px Arial";
        ctx.fillText(brightnessVal, x, y+50);

        ctx.fillStyle = "black";
        ctx.fillText(brightnessVal, x-2, y+48);


        if (isBright) {
            ctx.strokeStyle = "lightGreen";
            ctx.lineWidth = 15;
            ctx.arc(x, y, 20, 0, 2 * Math.PI);
            ctx.stroke();
        }
    }

    async function transmit() {
        // setIsTransmitting(true);
        async function short() {
            document.getElementById("flashbox").style.background = "white";
            await new Promise(resolve => setTimeout(resolve, 200));
            document.getElementById("flashbox").style.background = "black";
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        async function long() {
            document.getElementById("flashbox").style.background = "white";
            await new Promise(resolve => setTimeout(resolve, 600));
            document.getElementById("flashbox").style.background = "black";
            await new Promise(resolve => setTimeout(resolve, 200));
        }

        async function space() {
            document.getElementById("flashbox").style.background = "black";
            await new Promise(resolve => setTimeout(resolve, 1400));
        }

        async function letterGap() {
            document.getElementById("flashbox").style.background = "black";
            await new Promise(resolve => setTimeout(resolve, 600));
        }

        var str = toSend.toLowerCase();

        // give time for isTransmitting to update, and also for user to get ready
        await space();

        for (var i = 0; i < str.length; i++) {
            if (str[i] == " ") {
                await space();
                continue;
            }
            if (!trsmting || !isTransmitting) {
                // get out of function early if user wants to stop
                // console.log("getting out of loop")
                return;
            }
            if (reverseDct.hasOwnProperty(str[i])) {
                var ditdahs = reverseDct[str[i]];
                setCurrentLetter(str[i]);
                // console.log('trsmting, isTransmigging:', trsmting, isTransmitting)
                for (var j = 0; j < ditdahs.length; j++) {
                    if (!trsmting) {
                        // get out of function early if user wants to stop
                        // console.log("getting out of loop")
                        return;
                    }
                    if (ditdahs[j] == "-") {
                        await long();
                    } else if (ditdahs[j] == ".") {
                        await short();
                    }
                }
                await letterGap();
            }
        }
        await space();
        setCurrentLetter("")
        document.getElementById("flashbox").style.background = "white";
        setIsTransmitting(false);
    }

    function handleResize() {
        setScreenHeight(window.screen.height);
        setScreenWidth(window.screen.width);
    }

    var trsmting = false;
    useEffect(() => {
        if (isTransmitting) {
            trsmting = true;
            transmit();
        } else {
            // console.log("isTransmitting is",isTransmitting)
            trsmting = false;
            // console.log("trsmting is",trsmting)
        }
      }, [isTransmitting]);

    
      useEffect(() => {
        
        
        handleResize();
        // VIDEO CAPTURE
        
        const video = document.querySelector("video"); 

        function capture(elementSelector, facingMode) {
          const element = document.querySelector(elementSelector);
          const constraints = {
              video: { facingMode: facingMode },
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
          element.onclick = function () {
              navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess).catch(handleError);
          };
      }
      });

    var video = document.querySelector("video");

    function handleStop() {
        setIsTransmitting(false);
        setValue(1);
        setCurrentLetter("")
        // console.log("setting transmiggint to false");
    }
    
    function handleSuccess(stream) {
        setStream(stream);
        video.srcObject = stream;
    }

    function closeStreams(stream) {
        // console.log("closing streams")
        stream.getTracks().forEach(function(track) {
            track.stop();
        });
    }

    function handleError(error) {
        console.error("Error: ", error);
    }

      function toggleCam(facingMode) {
        video = document.querySelector("video");
        const constraints = {
            video: { facingMode: facingMode },
        };
        navigator.mediaDevices.getUserMedia(constraints).then(handleSuccess).catch(handleError);
        setIsRecording(true);
      }

      useEffect(() => {
        if (isRecording) {
            var interval = setInterval(() => captureVideo(threshold), 33);
                return () => {
                clearInterval(interval);
            };
        } else {
            if (stream != null) {
                closeStreams(stream);
            }


            // navigator.mediaDevices.getUserMedia(constraints).then(closeStreams).catch(handleError);
            clearInterval(interval);
        }
      }, [threshold, isRecording]);
      
    return (
        <ThemeProvider theme={theme}>
        <div sx={{width:"100%", height:'100%', backgroundColor: "black",}}>
        <Stack sx={{width:"100%", height:'100%', alignItems:"center",
    backgroundColor: value===0? "black":"white"}} 
        direction="column" justifyContent="center"
        >

            { value == 1 && <>
            {/* <Box> */}
            {/* <head>
                <meta charset="utf-8" />
                <meta name="apple-mobile-web-app-title" content="Full Screen Cam" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        
                <title>Full Screen Cam</title>
            </head> */}
                <video autoPlay muted playsInline width="1"></video>


            
                { isRecording && 
            <Box>
            <canvas id="view" width="400" height="350" sx={{position:'absolute', left:0, right:0}}>
            </canvas>
            {/* <canvas id="port" width="50" height="50" sx={{position:'absolute', left:0, right:0}}> </canvas> */}
            </Box>
}

            { !isRecording && <>
                <Typography sx={{mt:1}} variant="h5"><b>S'Morse</b></Typography>
                <img src={logo} width='200px'  />
            <Button onClick={() => toggleCam("environment")} variant="contained"
             sx={{mt:2, width:300,height: '150px'}} >Start</Button>
            <Button onClick={() => toggleCam("user")} sx={{mt:1, width:300, color:"brown"}}>Front Camera</Button>
            
            </> }

            { isRecording && 
            <IconButton onClick={() => setIsRecording(false)}>
                <StopCircleIcon style={{fontSize: '40px', color:'salmon'}} />
            </IconButton> 
            }
            <Slider
                sx={{mt:1, width:300}}
                value={threshold}
                valueLabelDisplay="auto"
                onChange={(e, val) => setThreshold(val)}
                step={1}
                min={20}
                max={240}
                marks={marks}
            />
            <TextField label="Plain Text"
            value={decodedState.slice(-28,decodedState.length)}
            sx={{width:300, mt:1}}
            inputProps={{style: {fontSize: 25}}}
            />
            <TextField label="Morse" value={resState} sx={{width:300, mt:1}}></TextField>
            <TextField label="Frames" value={frmct} sx={{width:300, mb: '70px', mt:1}}></TextField>
            

            
            </>}

            {value === 2 && 
                <Stack sx={{width:"350px", height:'100%', 
                backgroundColor: value===0? "black":"white", mb:"100px"}} >
                    
                    <Typography variant="h6" sx={{mt:1}}>
                       <b>S'Morse</b> 
                    </Typography>

                    <Stack sx={{alignItems:"center", justifyContent:"center", width:'100%'}}>
                        <img src={logo} width='200px' />
                    </Stack>
                    <Typography variant="body1" sx={{mt:1}}>
                        Communicate with people around you with morse code!
                        S'Morse uses your phone's camera and screen to send & receive messages with other people
                        across distance without having to know morse code, or people's contact information. 
                    </Typography>

                    <Typography variant="h6" sx={{mt:1}}>
                       <b>Transmitting</b> 
                    </Typography>

                    <Typography variant="body1" sx={{mt:1}}>
                        To transmit morse code, tap "Transmit" on the bottom left corner.
                        <br/>
                        1. Type the message you want to send <br/>
                        2. Turn screen brightness all the way up <br/>
                        3. Tap "Transmit" <br/>
                        4. Point your screen directly at the receiver and hold still until flashing stops
                    </Typography>

                    <Typography variant="h6" sx={{mt:1}}>
                       <b>Receiving</b> 
                    </Typography>

                    <Typography variant="body1" sx={{mt:1}}>
                        To receive morse code, tap "Receive" at the center of the bottom navigation.<br/>
                        <img src={startcomp} width="75px" /><br/>
                        1. Tap "Start" to turn on your camera and point it at the flashing light.
                        
                         <br/>
                         <img src={oncomp} width="75px" /> <img src={offcomp} width="75px" /><br/>
                        2. Keep the flashing light inside the blue circle; it should turn 
                        green only when the light is on.  <br/>
                        <img src={slidercomp} width="300px" /><br/>
                        3. Use the slide bar to adjust light sensitivity. The sensitivity should be
                        higher than the brightness when the light is off, and lower than the brightness
                        when the light is on.
                    </Typography>
                </Stack>
            }

            {value === 0 && 
                <Stack id="flashbox" sx={{width:"100%", height:screenHeight-200,
                alignItems:"center", justifyContent:"center", backgroundColor: "white"}} spacing={2}>
                        {/* <Typography variant="h5" sx={{mt:1, color:"black"}} >
                            Transmit
                        </Typography> */}

                        { !isTransmitting &&
                            <TextField variant="outlined" sx={{ }} value={toSend} autoFocus
                            onChange={(e) => setToSend(e.target.value)} label="Message"></TextField>
                        }

                        {currentLetter !== "" &&
                            <Typography variant="h1" sx={{color:"black"}}>
                            {currentLetter.toUpperCase()} <br/>
                            {reverseDct[currentLetter]}
                            </Typography>
                        }

                        <Button onClick={
                            isTransmitting ?
                            () => handleStop()
                            : () => setIsTransmitting(true)
                        }  sx={{}}>
                            {isTransmitting ? "stop" : "transmit"}
                        </Button>
                </Stack>
            }

        <Box sx={{ width: 500,zIndex: 100 }}>
                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0,zIndex: 100 }} elevation={3}>
                    <BottomNavigation 
                    showLabels
                    sx={{display:{xs: "flex", md:"flex"},zIndex: 100}}
                    value={ value }
                        onChange={(event, newValue) => {
                            if (isRecording) {
                                setIsRecording(false);
                                if (stream != null) {
                                    closeStreams(stream);
                                }
                            }
                            setValue(newValue);
                        }}
                    >
                        <BottomNavigationAction label="Transmit"
                        icon={ <HighlightIcon /> }/>
                        <BottomNavigationAction label="Receive"
                        icon={ <SubtitlesIcon /> }/>
                        <BottomNavigationAction label="Info"
                        icon={ <InfoIcon/>} />

                    </BottomNavigation> 
                </Paper>
        </Box>

        </Stack>
        </div>
        </ThemeProvider>
    );
  };
  
  export default WebcamStreamCapture; //InfoIcon